/* eslint-disable eqeqeq */
/**
 * Apply functionality to blocks.
 *
 * TODO: review the eqeqeq later.
 * TODO: review the screen global.
 * TODO: keyCode is deprecated, update to new approach.
 */

import { Swiper, Navigation, Pagination } from 'swiper';
import 'swiper/css';
Swiper.use([Navigation, Pagination]);

jQuery(($) => {
  // Slick Carousels
  if ($('.testimonial-block')) {
    const swiper = new Swiper('.testimonial-slider', {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  function removeClasses() {
    $('.rwl-map-modal').removeClass('show').removeClass('reverse');
  }

  if ($('.map-block').length) {
    const mqWidth = window.matchMedia('(min-width: 48em)');
    const screen = window.matchMedia('screen');

    // Need to be able to recheck this on resize
    // eslint-disable-next-line no-restricted-globals
    if (mqWidth.matches && screen.matches) {
      $('#show-map').on('click', (e) => {
        (e).preventDefault();
        $('.rwl-map-modal').addClass('show');
        $('body').addClass('no-scroll');
      });

      $('#close-map-modal').on('click', () => {
        $('.rwl-map-modal').addClass('reverse');
        $('#rwl-district-info').removeClass('show');
        $('.rwl-district-details').remove();
        $('body').removeClass('no-scroll');
        setTimeout(removeClasses, 1250);
      });

      $(document).on('keydown', (e) => {
        if (e.keyCode == 27) {
          if (!$('#rwl-district-info').hasClass('show')) {
            if ($('.rwl-map-modal').hasClass('show')) {
              $('.rwl-map-modal').addClass('reverse');
              $('#rwl-district-info').removeClass('show');
              $('.rwl-district-details').remove();
              $('body').removeClass('no-scroll');
              setTimeout(removeClasses, 1250);
            }
          }
        }
      });
    }
  }

  if ($('.collaborators-block')) {
    const swiper = new Swiper('.collaborators-listing .swiper', {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 2,
          slidesPerGroup: 2,
        },

        750: {
          slidesPerView: 3,
          slidesPerGroup: 3,
        },
        1024: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        },
      },
    });
  }

  // Tabbed Navigation
  $('.tabs-nav ol').on('scroll', () => {
    const position = $('.tabs-nav ol').scrollLeft();
    const $right = Math.round($('.tabs-nav li:last-child').width());
    const $left = Math.round($('.tabs-nav li:first-child').width());

    if (position > $left && !$('.tabs-nav-prev-btn').hasClass('show')) {
      $('.tabs-nav-prev-btn').addClass('show');
    }

    if (position <= $left && $('.tabs-nav-prev-btn').hasClass('show')) {
      $('.tabs-nav-prev-btn').removeClass('show');
    }

    const scroller = document.querySelector('.tabs-nav ol');
    if (position + window.innerWidth - scroller.scrollWidth > -$right) {
      $('.tabs-nav-next-btn').addClass('hide');
    } else {
      $('.tabs-nav-next-btn').removeClass('hide');
    }
  });

  $('.tabs-nav-next-btn').on('click', () => {
    $('.tabs-nav ol').animate({ scrollLeft: 2400 });
  });

  $('.tabs-nav-prev-btn').on('click', () => {
    $('.tabs-nav ol').animate({ scrollLeft: 0 });
  });

  function showCurrentTab() {
    const active = document.querySelector('.tabs-nav button.active');
    active.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    const scroller = document.querySelector('.tabs-nav ol');
    const position = $('.tabs-nav ol').scrollLeft();
    const $right = Math.round($('.tabs-nav li:last-child').width());
    const $left = Math.round($('.tabs-nav li:first-child').width());

    if (position > $left && !$('.tabs-nav-prev-btn').hasClass('show')) {
      $('.tabs-nav-prev-btn').addClass('show');
    }

    if (position <= $left && $('.tabs-nav-prev-btn').hasClass('show')) {
      $('.tabs-nav-prev-btn').removeClass('show');
    }

    if (position + window.innerWidth - scroller.scrollWidth > -$right) {
      $('.tabs-nav-next-btn').addClass('hide');
    } else {
      $('.tabs-nav-next-btn').removeClass('hide');
    }
  }

  // Tabbed Component Functionality
  $('.tabs-component .select-box').on('click', () => {
    $(this).next().toggleClass('show');
  });

  function tabsNav(target, index, text) {
    $('.tabs-component.current').removeClass('current');
    target.parents('.tabs-component').addClass('current');
    $('.tabs-component.current .tabs-nav button.active').removeClass('active');
    $('.tabs-component.current .tabs-progress button.active').removeClass('active');
    $('.tabs-component.current .tabs-panel.open').attr('aria-hidden', 'true').removeClass('open');
    target.addClass('active');
    $('.tabs-progress li').eq(index).children('button').addClass('active');
    $('.tabs-component.current .tabs-panel').eq(index).attr('aria-hidden', 'false').addClass('open');
    target.parents()
      .removeClass('show')
      .prev()
      .children('.text')
      .text(text);
  }

  function tabsProgress(target, index, text) {
    $('.tabs-component.current').removeClass('current');
    target.parents('.tabs-component').addClass('current');
    $('.tabs-component.current .tabs-progress button.active').removeClass('active');
    $('.tabs-component.current .tabs-nav button.active').removeClass('active');
    $('.tabs-component.current .tabs-panel.open').attr('aria-hidden', 'true').removeClass('open');
    target.addClass('active');
    $('.tabs-nav li').eq(index).children('button').addClass('active');
    $('.tabs-component.current .tabs-panel').eq(index).attr('aria-hidden', 'false').addClass('open');
    $('.tabs-nav')
      .removeClass('show')
      .prev()
      .children('.text')
      .text(text);
  }

  function tabs() {
    $('.tabs-panel').attr('aria-hidden', 'true');
    $('.tabs-nav li:first-child button, .tabs-progress li:first-child button').addClass('active');
    $('.tabs-panel:first-child').attr('aria-hidden', 'false').addClass('open');

    $('.tabs-nav li button').on('click', () => {
      const $target = $(this);
      const $index = $(this).parent().index();
      const $text = $(this).text();
      tabsNav($target, $index, $text);
      showCurrentTab();
    });

    $('.tabs-progress button').on('click', () => {
      const $target = $(this);
      const $index = $(this).parent().index();
      const $text = $(this).text();
      tabsProgress($target, $index, $text);
      showCurrentTab();
    });
  }

  tabs();

  if ($('.tabbed-block')) {
    $('.tab-heading').on('click', () => {
      $(this).toggleClass('expanded');
      $(this).next().toggleClass('expanded');
    });
  }

  if ($('.accordion-block')) {
    $('.accordion-heading').attr('aria-expanded', 'false');
    $('.accordion-text-content').attr('aria-hidden', 'true').removeClass('open');

    $('.accordion-heading').on('click', function() {
      const heading = $(this);
      $(heading).toggleClass('expanded');

      if ($(heading).hasClass('expanded')) {
        $(heading).attr('aria-expanded', 'true');
        $(heading).parent().addClass('expanded');
        $(heading).next().attr('aria-hidden', 'false').addClass('open');
      } else {
        $(heading).attr('aria-expanded', 'false');
        $(heading).parent().removeClass('expanded');
        $(heading).next().attr('aria-hidden', 'true').removeClass('open');
      }
    });
  }
});
